import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { DashboardOverview } from "../../../lib/api";
import { formatMoney, formatNumber } from "./format";

const HeroValueCard: React.FC<{ inventory?: DashboardOverview["inventory"] }> = ({
  inventory,
}) => {
  const stats = [
    { label: "On rent", value: inventory?.totalRented },
    { label: "Available", value: inventory?.totalAvailable },
    { label: "Reserved", value: inventory?.totalReserved },
  ];

  return (
    <Link
      to="/inventory"
      className="relative block overflow-hidden rounded-3xl bg-gradient-to-br from-primary-500 via-primary-600 to-primary-800 p-5 text-white shadow-lg shadow-primary-600/20 transition-transform active:scale-[0.98]"
    >
      <span className="pointer-events-none absolute -right-10 -top-12 h-40 w-40 rounded-full bg-white/10" />
      <span className="pointer-events-none absolute -bottom-16 -left-8 h-36 w-36 rounded-full bg-white/5" />

      <div className="relative flex items-center justify-between">
        <p className="text-xs font-medium uppercase tracking-wide text-white/75">
          Total items value
        </p>
        <ChevronRight className="h-4 w-4 text-white/70" />
      </div>
      <p className="relative mt-1.5 text-[26px] font-bold font-jakarta leading-tight break-words">
        {formatMoney(inventory?.totalValue)}
      </p>

      <div className="relative mt-5 grid grid-cols-3 divide-x divide-white/15 rounded-2xl bg-white/10 py-3 backdrop-blur-sm">
        {stats.map((stat) => (
          <div key={stat.label} className="px-3 text-center">
            <p className="text-base font-semibold leading-tight">{formatNumber(stat.value)}</p>
            <p className="mt-0.5 text-[11px] text-white/75">{stat.label}</p>
          </div>
        ))}
      </div>
    </Link>
  );
};

export default HeroValueCard;
